<template>
  <vs-popup class="customer-site-create-popup" background-color-popup="danger" background-color="danger"
    title="CHANGE REQUEST" @close="open = false" :active.sync="open" :buttons-hidden="true">
    <div class="vx-row">
      <div class="vx-col w-2/5">
        <vx-card title="Submit new request" no-shadow>
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                  <small class="label">Request Type</small>
                  <v-select :clearable="false" name="country" placeholder="" label="name" v-model="form.type"
                    :options="[{ name: 'Cancel order', value: 'Cancel' }, { name: 'Change order quantity', value: 'Change' }]"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.value" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-row mt-4" v-if="form.type === 'Cancel'">
            <div class="vx-col">
              Current order item status: <span class="font-bold">{{ item_data.item_status || '' }}</span> <br>
              Requesting status: <span class="font-bold text-danger">Cancel</span>
            </div>
          </div>
          <div class="vx-row mt-4" v-if="form.type === 'Change'">
            <div class="vx-col">
              Current order item quantity (KG): <span class="font-bold">{{ Number(item_data.quantity).toFixed(3) }}</span> <br>
              Adjusted quantity required (KG): <vs-input v-model="requesting_qty"></vs-input>
            </div>
          </div>
          <div class="vx-row mb-3 mt-8">
            <div class="vx-col w-full">
              <small class="label">Comment</small>
              <vs-textarea class="mb-0" v-model="form.comment" height="150px" />
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button @click="onClickSubmit" button="submit" class="ml-auto mt-2">Submit</vs-button>
            <!-- <vs-button @click="open = false" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button> -->
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-3/5">
        <vx-card title="" no-shadow>

          <vs-table :data="request_list" id="popup">

            <template slot="thead">
              <vs-th>DATE/TIME</vs-th>
              <vs-th>REQUEST TYPE</vs-th>
              <vs-th>REQUEST STATUS</vs-th>
              <vs-th width="40%">DATA</vs-th>
              <vs-th width="20%">COMMENT</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].created_at">
                  {{ __dateTimeFormatter(data[indextr].created_at) }}
                </vs-td>

                <vs-td :data="data[indextr].type">
                  {{ data[indextr].type }}
                </vs-td>

                <vs-td :data="data[indextr].status">
                  <vs-chip style="border-radius: 0;">
                    {{ data[indextr].status }}
                  </vs-chip>
                </vs-td>

                <vs-td :data="data[indextr].data">
                  <span v-if="data[indextr].type === 'Change'">
                    From : <span class="font-bold">{{ data[indextr].data.from }} KG</span>
                    To : <span class="font-bold">{{ data[indextr].data.to }} KG</span>
                  </span>
                  <span v-else>N/A</span>
                </vs-td>

                <vs-td :data="data[indextr].comment">
                  {{ data[indextr].comment }}
                </vs-td>

              </vs-tr>
            </template>

          </vs-table>
        </vx-card>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const CustomerRepository = RepositoryFactory.get('customer')
import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    item_data: { item_status: '' },
    form: {
      type: null,
      data: {
        from: null,
        to: null
      }
    },
    requesting_qty: 0,
    request_list: []
  }
}

export default {
  name: 'CustomerOrderItemChangeRequestPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(data) {
      try {
        await Object.assign(this.$data, initialState())
        this.item_data = data
        await this.fetchRequestList()
        this.open = true;
      } catch (error) {
        console.log(error);
      }
    },
    async onClickSubmit() {
      await this.$vs.loading()
      try {
        if (this.form.type === 'Change') {
          this.form.data.from = Number(this.item_data.quantity).toFixed(3)
          this.form.data.to = Number(this.requesting_qty).toFixed(3)
        }
        if (this.form.type === 'Cancel') {
          delete this.form.data
        }
        await CustomerRepository.submitOrderItemChangeRequest(this.item_data.id, this.form)
        this.showSuccessMessage('Order item change request submitted successfully')
        this.form.type = null
        this.form.comment = ''
        this.form.data = {
          from: null,
          to: null
        }
        await this.fetchRequestList()
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    async fetchRequestList() {
      await this.$vs.loading()
      try {
        const { data } = await CustomerRepository.getListOfChangeReques(this.item_data.id)
        this.request_list = data.data
      } catch (error) {
        console.log(error);
      }
      this.$vs.loading.close()
    }

  },
  async mounted() {

  },
  components: {
    'v-select': vSelect
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.customer-site-create-popup>>>.vs-popup {
  /* min-height: 30% !important; */
  min-width: 80% !important;
}
</style>
